const API_BASE_URL =
  "https://islam-brasil-production.up.railway.app/halal-meat/frigorifico";

// Busca frigorífico pelo número extraído do texto digitado
export async function fetchFrigorifico(searchText) {
  const numberMatch = (searchText || "").match(/\d+/);
  if (!numberMatch) {
    return { encontrado: false, resultados: [] };
  }

  const response = await fetch(`${API_BASE_URL}/${numberMatch[0]}`);
  if (!response.ok) {
    throw new Error(`Erro na API: ${response.status}`);
  }

  return response.json();
}

// Mapeia o resultado da API para o modelo usado na interface
export function mapResultado(resultado) {
  return {
    companyName: resultado.nome,
    address: [resultado.cidade, resultado.estado]
      .filter(Boolean)
      .join(" - "),
    country: resultado.pais,
    products: resultado.produtos,
    certificateNumber: resultado.certificado,
    certifier: (resultado.certificadora || []).join(", "),
    recognition: resultado.requisitos
  };
}
